import { render, staticRenderFns } from "./CompetitionDetailLink.vue?vue&type=template&id=f5f0d85e&scoped=true"
import script from "./CompetitionDetailLink.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f0d85e",
  null
  
)

export default component.exports